/* eslint-disable */
import ko from 'knockout';
import _ from 'underscore';
import ko_schema from '@bingads-webui-component-legacy/ko-schema/index';
import addressSchema from '@bingads-webui-component-legacy/address/addressSchema';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!component/address');
var s$Address = window.globalLegacySchema.get('Address');
function setInputBindings(local, key) {
  var attrs = {
    key: key,
    value: local,
    type: 'input',
    cssSelector: key,
    placeholder: i18n.get('Address_Placeholder_' + key)
  };
  if (key === 'StreetAddress') {
    attrs.label = i18n.get('Address_Line1');
  } else if (key === 'StreetAddress2') {
    attrs.label = i18n.get('Address_Title_Optional', {
      title: i18n.get('Address_Line2')
    });
  }
  local.error = i18n.get('Address_Validation_Required');
  return attrs;
}
var ViewModel = function (options) {
  var self = this;
  if (!(_.isUndefined(options.model) || _.isEmpty(options.model)) && (_.isUndefined(options.model.ProvinceName) || _.isEmpty(options.model.ProvinceName)) && !(_.isUndefined(options.model.ProvinceCode) || _.isEmpty(options.model.ProvinceCode))) {
    options.model.ProvinceName = options.model.ProvinceCode;
  }
  ko_schema.properties(self, s$Address, ['StreetAddress', 'StreetAddress2', 'CityName', 'ProvinceName', 'CountryCode', 'PostalCode'], options.model);
  self.isEmptyByDefault = ko.observable(_.isEmpty(options.model));
  if (self.isEmptyByDefault()) {
    self.CountryCode(options.market);
  }
  self.countries = ko.observableArray([]);
  self.adminDistricts = ko.observableArray([]);
  self.inputProperties = ['StreetAddress', 'StreetAddress2', 'CityName', 'PostalCode'];
  _.each(self.inputProperties, function (key) {
    self[key + '_element'] = setInputBindings(self[key], key);
  });
  self.CountryCode_element = {
    label: i18n.get('Address_Country'),
    source: self.countries,
    type: 'selector',
    value: self.CountryCode,
    cssSelector: 'CountryCode',
    key: 'CountryCode',
    placeholder: ''
  };
  self.ProvinceName_element = {
    type: 'selector',
    source: self.adminDistricts,
    value: self.ProvinceName,
    cssSelector: 'ProvinceName',
    key: 'ProvinceName',
    placeholder: i18n.get('Address_Placeholder_ProvinceName')
  };
  self.ProvinceName_element.label = ko.computed(function () {
    var countryCode = self.CountryCode();
    return addressSchema.adminDistrictSchema(countryCode).Title;
  });
  self.CityName_element.label = ko.computed(function () {
    var countryCode = self.CountryCode();
    return addressSchema.localitySchema(countryCode).Title;
  });
  self.postalCodeSchema = ko.computed(function () {
    var countryCode = self.CountryCode();
    return addressSchema.postalCodeSchema(countryCode);
  });
  self.PostalCode_element.label = ko.computed(function () {
    return self.postalCodeSchema().Title;
  });
  self.PostalCode_element.placeholder = ko.computed(function () {
    return self.postalCodeSchema().IsZip ? i18n.get('Address_Placeholder_Zip') : i18n.get('Address_Placeholder_PostalCode');
  });
  self.StreetAddress.showError = ko.computed(function () {
    return !self.isEmptyByDefault() && _.isEmpty(self.StreetAddress());
  });
  self.StreetAddress2.showError = false;
  self.CityName.showError = ko.computed(function () {
    return !self.isEmptyByDefault() && _.isEmpty(self.CityName());
  });
  self.PostalCode.error = i18n.get('Address_Validation_PostalCode_Pattern');
  self.PostalCode.showError = ko.observable(false);
  ko.computed(function () {
    if (!_.isEmpty(self.PostalCode())) {
      self.PostalCode.showError(false);
    }
  });
  self.propertyList = ko.computed(function () {
    var countryCode = self.CountryCode(), format = addressSchema.displayFormat(countryCode), showFields = ['CountryCode'], match = [], re = /\{\{(\w*)\}\}/gm;
    while (match = re.exec(format)) {
      if (match[1] !== 'CountryCode') {
        showFields.push(match[1]);
      }
    }
    return showFields;
  });
  self.properties = ko.computed(function () {
    var showFields = self.propertyList();
    return _.map(showFields, function (field) {
      return self[field + '_element'];
    });
  });
  return self;
};
ViewModel.prototype.validatePostalCode = function () {
  var self = this;
  var urlregex = self.postalCodeSchema().Pattern, required = self.postalCodeSchema().Required;
  var error = !self.isEmptyByDefault() && (!_.isEmpty(self.PostalCode()) && !urlregex.test(self.PostalCode()) || required && _.isEmpty(self.PostalCode()));
  self.PostalCode.showError(error);
  return !error;
};
ViewModel.prototype.hasProvince = function () {
  return _.contains(this.propertyList(), 'ProvinceName');
};
ViewModel.prototype.isValid = function () {
  var self = this;
  return _.reduce([self.StreetAddress.validate(), _.contains(self.propertyList(), 'CityName') ? self.CityName.validate() : true, self.validatePostalCode()], function (init, next) {
    return init && next;
  }, true);
};
export default ViewModel;

